export function getTableHeightFitContent() {
    const documentHeight = document.documentElement.clientHeight;
    return documentHeight - document.getElementById('rdg').offsetTop;
}
